module.exports = __webpack_public_path__ + "static/Nicole-cb61df3b03a4c42bf36c6adc877169f2.png";